import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { GroupsDuoIcon, SearchDuoIcon } from "@flat-ui";
import { useAppSelector } from "@store/store-helper";
import { searchSelector } from "@store/ui/ui-selector";

/** Empty page content for groups page */
export function GroupsEmptyPage() {
  const $ = _c(3);
  const {
    debouncedSearchText
  } = useAppSelector(searchSelector);
  const {
    canCreateGroups
  } = useHasUserValidRoleCompanyLevel();
  if (debouncedSearchText.length) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <EmptyPage title="No results found" subtitle="There are no groups that match this search." icon={SearchDuoIcon} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  } else {
    let t0;
    if ($[1] !== canCreateGroups) {
      t0 = <EmptyPage title="You don't have a group yet" subtitle={canCreateGroups ? <>You haven't added groups to your workspace. Select the "new group" button to create one.</> : <>You haven't added groups to your workspace.</>} icon={GroupsDuoIcon} />;
      $[1] = canCreateGroups;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
}